
import { defineComponent, ref, computed, PropType } from 'vue'

import { mdiOpenInNew } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { MenuSubAttributes } from '@/types/models/menu-sub'
import { validateUrl, externalOrInternalLink, LINK_STATUS } from '@/utils/router'
import { toArray } from '@/utils/array'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    menuSubs: {
      type: Array as PropType<MenuSubAttributes[] | undefined>,
      'default': () => ([]),
    },
    isOpen: {
      type: Boolean,
      'default': () => (true),
    },
  },
  setup(props) {
    const route = useRoute()
    const submenuRef = ref<HTMLElement | undefined>(undefined)

    const switchHeightStyle = computed(() => {
      return props.isOpen ? `max-height: ${submenuRef.value?.scrollHeight}px` : ''
    })

    const currentUrl = computed(() => {
      return `${route.path}${window.location.search}`
    })

    return {
      switchHeightStyle,
      submenuRef,
      validateUrl,
      externalOrInternalLink,
      mdiOpenInNew,
      LINK_STATUS,
      toArray,
      currentUrl
    }
  },
})
